import * as React from "react";
import { forwardRef } from "react";
const SvgIntegration = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, rx: 4, fill: "#0C7EA3" }), /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, rx: 4, fill: "white", fillOpacity: 0.9 }), /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 23, height: 23, rx: 3.5, stroke: "#0C7EA3", strokeOpacity: 0.5 }));
const ForwardRef = forwardRef(SvgIntegration);
export { ForwardRef as ReactComponent };
